export default __webpack_public_path__ + "static/6857-2593ab3b46d048a28570f69e8dcfec55.jpg";